function getMetroFormatedDate(date) {
    const dateObj = date
    const dayInteger = dateObj.getDate()
    const monthInteger = parseInt(dateObj.getMonth() + 1 )
    const yearInteger = parseInt(dateObj.getFullYear())
    
    return  dayInteger + '.' + monthInteger + '.' + yearInteger
}

export default getMetroFormatedDate